import {Tab} from '@components/ui/tabs/tab';
import {
  APP_ENTITY_ASSETS,
  APP_ENTITY_BANKING,
  APP_ENTITY_DOCUMENTS,
  APP_ENTITY_HOLDINGS,
  APP_ENTITY_INFORMATION,
  APP_ENTITY_INVESTMENTS,
  APP_ENTITY_LOANS,
  APP_ENTITY_INVOICES,
  APP_ENTITY_RELATED_PARTIES,
  APP_ENTITY_SHARE_REGISTER
} from '../config/app-urls';

export class EntityTabs {
  public static readonly Information: Tab = {
    id: 'information',
    title: 'Information',
    appRoute: APP_ENTITY_INFORMATION
  };
  public static readonly RelatedParties: Tab = {
    id: 'related-parties',
    title: 'Related Parties',
    appRoute: APP_ENTITY_RELATED_PARTIES
  };
  public static readonly ShareRegister: Tab = {
    id: 'share-register',
    title: 'Share Register',
    appRoute: APP_ENTITY_SHARE_REGISTER
  };
  public static readonly Invoices: Tab = {
    id: 'invoices',
    title: 'Invoices',
    appRoute: APP_ENTITY_INVOICES
  };
  public static readonly Holdings: Tab = {
    id: 'holdings',
    title: 'Holdings',
    appRoute: APP_ENTITY_HOLDINGS
  };
  public static readonly Banking: Tab = {
    id: 'banking',
    title: 'Banking',
    appRoute: APP_ENTITY_BANKING
  };
  public static readonly Investments: Tab = {
    id: 'investments',
    title: 'Investments',
    appRoute: APP_ENTITY_INVESTMENTS
  };
  public static readonly Assets: Tab = {
    id: 'assets',
    title: 'Assets',
    appRoute: APP_ENTITY_ASSETS
  };
  public static readonly Loans: Tab = {
    id: 'loans',
    title: 'Loans',
    appRoute: APP_ENTITY_LOANS
  };
  public static readonly Documents: Tab = {
    id: 'documents',
    title: 'Documents',
    appRoute: APP_ENTITY_DOCUMENTS
  };
}
